export function supportsModuleScripts(): boolean {
  // Use the feature detection method if available
  if ("supports" in HTMLScriptElement) {
    return HTMLScriptElement.supports("module");
  }
  // Degrade to a brute force approach, noModule attribute implies module support
  return "noModule" in document.createElement("script");
}
